<script>
  import Select from 'svelte-select';
  import { customInputEvent, searchKeyByValue } from 'components/Helper.js';

  export let clientTypes;
  export let clientSubTypes;
  export let form;
  export let errors;
  export let handleChange;
  export let selectedClientId;
  export let unitIds;

  import { getContext } from 'svelte';
  const showDialog = getContext('showDialog');
  let addClientTypelabel;
  function addClientType() {
    if (addClientTypelabel) {
      let arr = $form.clientTypes;
      if (searchKeyByValue(arr, 'unitClientTypeId', addClientTypelabel.id) !== -1) {
        showDialog({ message: 'Client type already selected' });
      } else {
        arr.push({
          id: '',
          unitClientTypeId: addClientTypelabel.id,
          subClientTypes: [],
        });
        selectedClientId.push({
          label: addClientTypelabel,
          types: null,
        });
        $form.clientTypes = arr;
        addClientTypelabel = null;
      }
    } else {
      showDialog({ message: 'Please select client type' });
    }
  }

  // $: if($form.clientTypes.length == 0){
  //      addClientType()
  //  }

  const removeClientType = (key) => {
    let arr = $form.clientTypes;
    arr.splice(key, 1);
    $form.clientTypes = arr;

    let errorArr = $errors.clientTypes;
    errorArr.splice(key, 1);
    $errors.clientTypes = errorArr;

    let arrClient = selectedClientId;
    arrClient.splice(key, 1);
    selectedClientId = arrClient;
  };

  const setClientSubTypes = (id) => {
    let arr = [];
    if (clientSubTypes[id] != undefined) {
      arr = clientSubTypes[id];
    }
    return arr;
  };
</script>

<div class="p-3 h-100 d-flex flex-column">
  <div class="profile-content mx-auto w-100">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Client Type *</span></h3>
    </div>
  </div>
  <div class="profile-content mx-auto h-100 w-100">
    <div class="form-group mb-3">
      <div class="row align-items-center">
        <div class="col-md-3">
          <label
            for=""
            class="form-label mb-0">Client Type</label
          >
        </div>
        <div class="col-md-6">
          <div class="form-group select-block">
            <Select
              class="form-control"
              bind:selectedValue={addClientTypelabel}
              showChevron={true}
              isClearable={true}
              items={clientTypes}
              getSelectionLabel={(option) => {
                return option.name;
              }}
              on:select={(ev) => {
                addClientTypelabel = ev.detail;
                addClientType();
                setTimeout(() => {
                  addClientTypelabel = undefined;
                }, 100);
              }}
              optionIdentifier="id"
              getOptionLabel={(option) => {
                return option.name;
              }}
              placeholder="Select Client Type"
            />
          </div>
        </div>
        <!-- <div class="col-md-3">
		  <button
			on:click={addClientType}
			class="btn btn-link px-0 mb-0  shadow-none border-0 bg-transparent font-size-12">
			<img class="icon-10" alt="" src="/images/plus.svg" /> Add New
		  </button>
		</div> -->
      </div>
    </div>

    {#each $form.clientTypes as item, i}
      <div class="form-group mb-3">
        <label
          for=""
          class="form-label">Client Type</label
        >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <Select
                class="form-control"
                bind:selectedValue={selectedClientId[i].label}
                isDisabled={true}
                showIndicator={true}
                isClearable={false}
                items={clientTypes}
                name={'clientTypes[' + i + ']'}
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                on:select={(ev) => {
                  if ($form.clientTypes[i].unitClientTypeId != ev.detail.id) {
                    $form.clientTypes[i].unitClientTypeId = ev.detail.id;
                    $form.clientTypes[i].id = '';
                    $form.clientTypes[i].subClientTypes = undefined;
                    setTimeout(() => {
                      selectedClientId[i].types = null;
                    }, 100);
                    handleChange(
                      customInputEvent(`clientTypes[${i}].unitClientTypeId`, ev.detail.id),
                    );
                  } else if (setClientSubTypes($form.clientTypes[i].unitClientTypeId).length > 0) {
                    handleChange(
                      customInputEvent(
                        `clientTypes[${i}].unitClientTypeId`,
                        $form.clientTypes[i].unitClientTypeId,
                      ),
                    );
                  }
                }}
                on:clear={(ev) => {
                  //$form.clientTypes[i] = null
                }}
                optionIdentifier="id"
                getOptionLabel={(option) => {
                  return option.name;
                }}
                placeholder="Select Client Type"
              />
            </div>
          </div>
        </div>
      </div>
      {#if unitIds != undefined && $form.unitId != unitIds.outsourced_cfo && setClientSubTypes($form.clientTypes[i].unitClientTypeId).length != 0}
        <div class="form-group mb-2">
          <label
            for=""
            class="form-label">Client Sub Type</label
          >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <Select
                  class="form-control"
                  bind:selectedValue={selectedClientId[i].types}
                  showIndicator={true}
                  isClearable={false}
                  name={'subClientTypes[' + i + ']'}
                  items={setClientSubTypes($form.clientTypes[i].unitClientTypeId)}
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  on:select={(ev) => {
                    let subArr = [];
                    if (ev.detail !== null) {
                      ev.detail.forEach((element) => {
                        subArr.push({
                          id: '',
                          unitClientTypeId: element.id,
                        });
                      });
                    }
                    $form.clientTypes[i].subClientTypes = subArr;
                  }}
                  on:clear={(ev) => {
                    //$form.clientTypes[i].subClientTypes =  null
                  }}
                  optionIdentifier="id"
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  placeholder="Select Client Sub Type"
                  isMulti={true}
                />
              </div>
            </div>
          </div>
        </div>
      {/if}
      <!-- {#if i == 0}
		<hr />
		<div class="d-flex justify-content-end mb-2">
		  <button
			on:click={addClientType}
			class="btn btn-link px-0 mb-0  shadow-none border-0 bg-transparent font-size-12">
			<img class="icon-10" alt="" src="/images/plus.svg" /> Add More
		  </button>
		</div>
	  {:else} -->
      <div class="d-flex justify-content-end mb-2">
        <button
          on:click={() => removeClientType(i)}
          class="btn btn-link px-0 mb-0 box-shadow-none shadow-none border-0 bg-transparent font-size-12 color-red"
        >
          <img
            alt=""
            class="icon-16 me-1"
            src="/images/trash.svg"
          /> Remove
        </button>
      </div>
      <!-- {/if} -->
    {/each}

    <!-- <ClientTypeItem subtype={true} addmore={true} /> -->
  </div>
</div>
